// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35FHn","toggle":"styles_toggle__Hs1Nw","preview":"styles_preview__3mX4p"};